module.exports = __webpack_public_path__ + "static/img/about_mapbg.faa5c53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_mapbg.png
// module id = 670
// module chunks = 57